import SectionHeading from '@/pages/home/components/SectionHeading';
import { watchGuides } from '@/mocks/home';

export default function WatchSection() {
  return (
    <section id="watch" className="border-t border-background-200 bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <SectionHeading
          eyebrow="观看指南"
          title="想看这部剧，走这几条正规路径"
          desc="我们刻意不收集任何下载或播放链接，而是把靠谱的观看方式讲清楚。支持正版，也是让它能持续更新的前提。"
        />

        <div className="mt-10 grid grid-cols-1 gap-10 md:mt-14 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-16">
          <div className="reveal order-2 lg:order-1">
            <div className="overflow-hidden rounded-lg border border-background-200">
              <div className="h-56 w-full md:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20cozy%20dim%20living%20room%20at%20night%2C%20a%20soft%20glowing%20screen%20casting%20warm%20light%20across%20the%20room%2C%20a%20cup%20of%20tea%20and%20an%20open%20notebook%20on%20a%20wooden%20table%2C%20warm%20amber%20and%20deep%20wine%20toned%20palette%2C%20shallow%20depth%20of%20field%2C%20subtle%20film%20grain%2C%20calm%20editorial%20photography%2C%20no%20text&width=1400&height=900&seq=ds-watch-01&orientation=landscape"
                  alt="夜晚温暖的客厅里，屏幕的微光映在桌面的茶杯与本子上，营造出正版追剧的居家氛围"
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          <div className="order-1 space-y-4 lg:order-2">
            {watchGuides.map((guide) => (
              <article
                key={guide.title}
                className="reveal flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-800">
                  <i className={`${guide.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950">
                    {guide.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-7 text-foreground-600">{guide.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="reveal mt-8 flex flex-col items-start gap-3 rounded-lg border border-primary-200 bg-primary-50 p-5 md:flex-row md:items-center md:gap-4 md:p-6">
          <i className="ri-heart-3-line text-2xl text-primary-600" aria-hidden="true"></i>
          <p className="text-sm leading-7 text-foreground-700 md:text-base">
            本页不存储、不分享任何影视资源的下载地址或播放链接。请通过正版渠道观看，让好内容得到应有的支持。
          </p>
        </div>
      </div>
    </section>
  );
}